export enum PublishType {
  Course = "course",
  Content = "content",
}

export const PublishSettings = [
  { value: true, label: "公開" },
  { value: false, label: "非公開" },
];
